import React from "react";
import CryptoJS from "crypto-js";

import { Navigate } from "react-router-dom";

import Layouts from "./Layouts";

import AccessDenied from "../exceptions/AccessDenied.jsx";

export const ProtectedRoute = ({ permission }) => {
  const authenticated = window.localStorage.getItem("token");

  if (!authenticated) return <Navigate to="/" />;

  let user = null; // Initialize user outside the if block

  if (!!authenticated) {
    const encryptedUser = window.localStorage.getItem("user");
    // Ensure encryptedUser is not null or undefined before decrypting
    if (encryptedUser) {
      const decryptedUser = CryptoJS.AES.decrypt(
        encryptedUser,
        process.env.REACT_APP_SECRET_KEY
      ).toString(CryptoJS.enc.Utf8);

      try {
        user = JSON.parse(decryptedUser);
      } catch (error) {
        console.error("Error parsing decrypted user data:", error);
        // Handle cases where decrypted data is not valid JSON
        return <Navigate to="/" />; // Or render an error page
      }
    } else {
      // If no encrypted user data, redirect to login
      return <Navigate to="/" />;
    }
  }

  // If user object is not available after decryption/parsing, redirect to login
  if (!user || !user.permissions) {
    return <Navigate to="/" />;
  }

  // Permission checking logic
  const hasPermission = () => {
    if (permission === undefined) {
      return true; // No specific permission required
    }

    if (Array.isArray(permission)) {
      // If permission is an array, check if user has ANY of the permissions
      return permission.some((p) => user.permissions.includes(p));
    } else {
      // If permission is a number (or a single string, though your prompt implies number)
      // Check if user's permissions include this single permission
      return user.permissions.includes(permission);
    }
  };

  return hasPermission() ? <Layouts /> : <AccessDenied />;
};
